export const STATUS = {
  active: '有効',
  inactive: '無効'
};
